<div class="anvil-page">
	<div id="layout-navbar">
		<%- include('nav') %>
	</div>
	<div id="layout-content">
		<%- include('../' + content.template, content.data) %>
	</div>
</div>
